import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto min-h-full" }

import SimpleFooter from '@/components/tailwind/footer/SimpleFooter.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'FacebookLiveReportLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterView)
    ]),
    _createVNode(SimpleFooter, { horizontal: true })
  ], 64))
}
}

})